// Dynamic localization loader
// Import default locale for type safety
import defaultStrings from './en-US/index.json';

// All string files will be imported via Vite glob
const localeModules = import.meta.glob('./*/index.json', { eager: true }) as Record<
  string,
  { default: Record<string, string> }
>;

// Type for our string keys
export type StringKey = keyof typeof defaultStrings;

// Pick the best matching locale bundle
function loadStrings(): Record<string, string> {
  const nav = navigator.language || 'en-US';
  const [lang, region] = nav.split(/[-_]/);
  
  // try exact match first, e.g. "fr-FR"
  if (region) {
    const exactKey = `./${lang}-${region}/index.json`;
    if (localeModules[exactKey]) {
      return localeModules[exactKey].default;
    }
  }
  
  // fallback to language only, e.g. "fr"
  const langKey = `./${lang}/index.json`;
  if (localeModules[langKey]) {
    return localeModules[langKey].default;
  }
  
  // fallback to any locale with the same language prefix
  const availableKeys = Object.keys(localeModules);
  const languageMatch = availableKeys.find(key => key.startsWith(`./${lang}-`));
  if (languageMatch) {
    return localeModules[languageMatch].default;
  }
  
  // final fallback
  return defaultStrings;
}

// Loaded strings for current user locale
const strings = loadStrings();

/**
 * Returns the localized string for the given key.
 */
export function t(key: StringKey): string {
  return strings[key] || defaultStrings[key] || key;
}